export default __webpack_public_path__ + "static/viz/media/neptune-icon.49c1658c.svg";